import React, { createContext } from 'react'
import { useSetState } from 'react-use'
import { INTERVAL_DURATION_DAYS } from '@/utils/constants'

interface State {
  intervalDuration: number
}

interface BookingViewStateValue {
  bookingViewState: State
  setBookingViewState: (state: Partial<State>) => void
}

export const BookingViewContext = createContext({} as BookingViewStateValue)

interface Props {
  children: React.ReactNode
  initialState?: Partial<State>
}

export const BookingViewStateProvider = ({ children, initialState }: Props) => {
  const [state, setState] = useSetState<State>({
    intervalDuration: INTERVAL_DURATION_DAYS,
    ...initialState,
  })

  const contextValue = {
    bookingViewState: state,
    setBookingViewState: setState,
  }

  return <BookingViewContext value={contextValue}>{children}</BookingViewContext>
}
